if (!customElements.get('sticky-buy-bar')) {
	customElements.define(
		'sticky-buy-bar',
		class StickyBuyBar extends HTMLElement {
			connectedCallback() {
				this.sectionId = this.dataset.sectionId;
				this.priceWrapper = this.querySelector('[data-sticky-price]');
				this.button = this.querySelector('[data-sticky-button]');
				this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
				this.observeTarget = document.getElementById(`Price-Wrapper-${this.sectionId}`) || this.mainButton;

				if (this.observeTarget && 'IntersectionObserver' in window) {
					this.intersectionObserver = new IntersectionObserver((entries) => {
						this.classList.toggle('product__sticky-cta--visible', !entries[0].isIntersecting);
					});
					this.intersectionObserver.observe(this.observeTarget);
				}

				this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
					if (event.data.sectionId !== this.sectionId) return;

					const updatedPrice = event.data.html.getElementById(`StickyCtaPrice-${this.sectionId}`);
					if (updatedPrice && this.priceWrapper) {
						this.priceWrapper.innerHTML = updatedPrice.innerHTML;
					}

					const updatedButton = event.data.html.getElementById(`StickyCtaButton-${this.sectionId}`);
					if (updatedButton && this.button) {
						this.button.toggleAttribute('disabled', updatedButton.hasAttribute('disabled'));
						this.button.textContent = updatedButton.textContent.trim();
					}
				});
			}

			disconnectedCallback() {
				if (this.intersectionObserver) this.intersectionObserver.disconnect();
				if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
			}
		}
	);
}
